import { createSSRApp }		  from 'vue'
import clientPlugin         from "@core/vuejs/js/plugins/client.plugin";
import httpPlugin           from "@core/vuejs/js/plugins/http.plugin";
import scrollDirective 		  from "@core/vuejs/js/directives/scroll"

/**
 * Build entries for Client and Server side.
 */
class ClientFactoryService
{
  /**
   * Returns client entry.
   *
   * @param component
   */
  createApp(component, rootContainer = '#app', componentsToRegister = [], Store = null)
  {
    if (window.iProfesional) {
      Store.commit('admin/setContext', window.iProfesional.admin);
    }

    const app = createSSRApp(component)
      .use(clientPlugin)
      .use(httpPlugin)
      .directive('scroll', scrollDirective)
    ;

    if (Store) {
      app.use(Store)
    }

    app.config.globalProperties.$settings = window.__SETTINGS__ ?? {}

    componentsToRegister.forEach(registerComponent => {
      registerComponent(app)
    })

    app.mount(rootContainer, true)
  }
}

export default new ClientFactoryService()